import loading_animation from "../../assets/loading_animation.gif"
import px from "../../constant/scripts/px"
import { CENTER, FILL_PARENT, GRID, VH_100 } from "../../constant/typograpy/properties"
export default function Loading () {

    return <div style={{width:FILL_PARENT, height:VH_100, display:GRID, placeItems:CENTER}}>
    <img width={px(100)} src={loading_animation}></img> </div>
}